/**
 * Token Storage Utilities
 * 
 * Separated from axios-config to avoid circular import issues
 * with authSlice.ts
 */

const TOKEN_KEY = 'auth_token';
const REFRESH_TOKEN_KEY = 'refresh_token';
const ADMIN_TOKEN_KEY = 'admin_token';

/**
 * Get stored tokens from localStorage
 */
export const getStoredToken = (): string | null => {
    return localStorage.getItem(TOKEN_KEY);
};

export const getStoredAdminToken = (): string | null => {
    return localStorage.getItem(ADMIN_TOKEN_KEY);
};

export const getStoredRefreshToken = (): string | null => {
    return localStorage.getItem(REFRESH_TOKEN_KEY);
};

/**
 * Store tokens in localStorage
 */
export const storeTokens = (accessToken: string, refreshToken?: string): void => {
    localStorage.setItem(TOKEN_KEY, accessToken);
    if (refreshToken) {
        localStorage.setItem(REFRESH_TOKEN_KEY, refreshToken);
    }
};

export const storeAdminToken = (token: string): void => {
    localStorage.setItem(ADMIN_TOKEN_KEY, token);
};

/**
 * Clear all stored tokens
 */
export const clearTokens = (): void => {
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem(REFRESH_TOKEN_KEY);
    localStorage.removeItem(ADMIN_TOKEN_KEY);
};
